require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.filter");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

module.exports = prepareSimpleTextSearch; // Usage:
//  ```
//    var get = simpleTextSearch(['foo', 'bar', 'foobar'])
//    var results = get('foo')
//    // -> returns ['foo', 'foobar']
//  ```
//
//  Objects in a collection get stringified to search it.
//  You can also define a property to search in:
//  ```
//    var get = simpleTextSearch([{name: 'Zürich'}, {name: 'Marc'}], 'name')
//    var results = get('zurich')
//    // -> returns [{name: 'Marc'}]
//  ```

function prepareSimpleTextSearch(collection, property) {
  return function simpleTextSearch(q) {
    if (!collection || !q) return collection;
    var filter = matches(toQuery(q), property);
    var result = [];

    var _iterator = _createForOfIteratorHelper(collection),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var elem = _step.value;
        if (filter(elem)) result.push(elem);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return result;
  };
}

function toQuery(str) {
  return clean(str).split(/\b/).filter(function (token) {
    return /\b/.test(token);
  });
}

function matches(query, prop) {
  return function filter(val) {
    if (typeof prop === 'string') val = val && val[prop];
    if (typeof val === 'object') val = JSON.stringify(val);
    if (typeof val !== 'string') return false;

    for (var i = 0; i < query.length; i++) {
      if (!~clean(val).indexOf(query[i])) {
        return false;
      }
    }

    return true;
  };
}

var replaceChar = charReplacer();

function clean(str) {
  return replaceChar(String(str).toLowerCase());
}

function charReplacer() {
  var charMap = {
    äàáâäæãåā: 'a',
    çćč: 'c',
    đð: 'd',
    èéêëēėę: 'e',
    îïíīįì: 'i',
    ł: 'l',
    ñńň: 'n',
    ôöòóœøōõ: 'o',
    ř: 'r',
    śš: 's',
    ß: 'ss',
    ť: 't',
    ûüùúūů: 'u',
    ÿý: 'y',
    žżŻź: 'z'
  };
  Object.keys(charMap).forEach(function (keys) {
    keys.split('').forEach(function (_char) {
      charMap[_char] = charMap[keys];
    });
  });
  var toReplace = new RegExp('[' + Object.keys(charMap).join('') + ']', 'g');

  function replacer(_char2) {
    return charMap[_char2] || _char2;
  }

  return function replaceChars(str) {
    return str.replace(toReplace, replacer);
  };
}